/**
 * Generates complete SQL block with all setup commands for Snowflake managed key authentication
 *
 * @param username - The Snowflake username to create/configure
 * @param warehouse - The warehouse name to create/configure
 * @param role - The role name to create/configure
 * @param publicKey - The RSA public key for authentication
 * @returns Complete SQL setup script as a string
 */
export function generateCompleteSqlBlock(username: string, warehouse: string, role: string, publicKey: string): string {
  return `USE ROLE ${role};

-- Create a small, resumable warehouse for DataOps tasks
CREATE WAREHOUSE IF NOT EXISTS ${warehouse}
    WITH WAREHOUSE_SIZE = 'X-SMALL'
         AUTO_SUSPEND = 60
         AUTO_RESUME = TRUE
         INITIALLY_SUSPENDED = TRUE
         COMMENT = 'DataOps warehouse';

-- Create a dedicated service user
USE ROLE USERADMIN;
CREATE USER IF NOT EXISTS ${username}
    TYPE = SERVICE
    DEFAULT_WAREHOUSE = ${warehouse}
    DEFAULT_ROLE = ${role}
    DISPLAY_NAME = 'DataOps Service User';

USE ROLE SECURITYADMIN;
GRANT ROLE ${role} TO USER ${username};

-- Add the public key for authentication
ALTER USER ${username} SET RSA_PUBLIC_KEY='${publicKey}';`;
}
